import { defineStore } from "pinia";
import { CommonHttp } from "@/models/interfaces/http/common.http.request";
import { reactive } from "vue";
import { rootStore } from "../index";
import { ParameterInstance } from "../../models/interfaces/parameters/parameter-models";


/**
 * Методы АПИ управления параметрами
 */

const API_URL = process.env.VUE_APP_API_URL

interface QueryState {
    loading: boolean;
    // ignore the request result and don't mutate the model after the request is finished
    stop_request: boolean;
    // asynchronous queue
    reqQueue: Map<string, AbortController>;
}

export const parameterStore = defineStore("parameterStore", {
  state: () =>
    ({
        loading: false,
        // ignore the request result and don't mutate the model after the request is finished
        stop_request: false,

        reqQueue: new Map()
    } as QueryState),

  actions: {

    // GET

    // GET Project Parameters and Bills
    async getProject(projectId: number = 66853) {
      const rootstore = rootStore()
      this.stop_request = false

      const entkey = 'project_data';

      // abort all other entity/graph result connections because only one element can be displayed at a time
      Array.from(this.reqQueue.entries()).forEach(([key, value]) => {
        if (key === entkey) {
          console.log('abort conn '+key)
          this.reqQueue.get(key)?.abort();
          this.reqQueue.delete(key);
        }
      });

      const controller = new AbortController();
      this.reqQueue.set(entkey, controller);

      const http = new CommonHttp(API_URL, rootstore.globalJWT)
      try {
        this.loading = true
        let response: any = undefined

        // const body = '\''+JSON.stringify({
        //   Id: projectId,
        //   ChangerId: rootstore.oldAPIUID,
        //   SessionKey: rootstore.oldAPISessionKey
        // })+'\'';

        await http.get(`projects/${projectId}`, { signal: controller.signal,
        // Override the default transformRequest
        // transformRequest: [
        //   (data: any) => {
        //     // If the data is a string (and presumably already JSON), return it directly.
        //     if (typeof data === 'string') {
        //       return data;
        //     }
        //     // If it's an object (or other type), you might need to handle it differently
        //     // or simply return it as is if you are sure it is pre-formatted.
        //     return data; 
        //   }
        // ]
       }).then(res => {
          response = res
          this.reqQueue.delete(entkey);
        }).catch(err => {
          console.log(err);
          this.reqQueue.delete(entkey);
        });

        // @ts-ignore
        if (response && (response.status === 200 || response.status === 201)) {
          // this.storages_with_items = reactive({} as any);
          // reactive filters change and update directly from interface
          const { data } = response;

          console.log(data)
          // this.storages_with_items = reactive(data);

          this.loading = false
          return reactive(data)
        } else {
          console.log('Error response status:', response?.status);
        }
      } catch (e) {
        console.log(JSON.stringify(e))
        this.loading = false
      }

      this.loading = false
      return undefined
    },

    // EDIT

    // POST remove parameter list field
    async removeListField(arg: number, isRecordField: boolean) {
      const rootstore = rootStore()
      this.stop_request = false
      const http = new CommonHttp(API_URL, rootstore.globalJWT)
      try {
        this.loading = true
        let response: any = undefined

        await http.delete(`parameters/instances/${arg}/${isRecordField ? 'from-field-list' : 'from-parameter-list'}`).then(res => {
          response = res
        }).catch(err => {
          console.log(err);
        });

        // @ts-ignore
        if (response && (response.status === 200 || response.status === 201)) {
          this.loading = false
          const { data } = response;
          this.loading = false
          return data
        } else {
          console.log('Error response status:', response?.status);
        }
      } catch (e) {
        console.log(JSON.stringify(e))
        this.loading = false
      }

      this.loading = false
      return { response_ok: false }
    },

    async addListField(arg: number, isRecordField: boolean) {
      const rootstore = rootStore()
      this.stop_request = false
      const http = new CommonHttp(API_URL, rootstore.globalJWT)
      try {
        this.loading = true
        let response: any = undefined

        await http.post(`parameters/instances/${isRecordField ? 'to-field-list' : 'to-parameter-list'}/${arg}`, {}).then(res => {
          response = res
        }).catch(err => {
          console.log(err);
        });

        // @ts-ignore
        if (response && (response.status === 200 || response.status === 201)) {
          this.loading = false
          const { data } = response;
          this.loading = false
          return data
        } else {
          console.log('Error response status:', response?.status);
        }
      } catch (e) {
        console.log(JSON.stringify(e))
        this.loading = false
      }

      this.loading = false
      return { response_ok: false }
    },

    // value differs depending on the data
    async editField(id: number, arg: any) {
      const rootstore = rootStore()
      this.stop_request = false
      const http = new CommonHttp(API_URL, rootstore.globalJWT)
      try {
        this.loading = true
        let response: any = undefined

        await http.patch(`parameters/instances/${id}/field-value`, arg).then(res => {
          response = res
        }).catch(err => {
          console.log(err);
        });

        // @ts-ignore
        if (response && (response.status === 200 || response.status === 201)) {
          this.loading = false
          const { data } = response;
          this.loading = false
          return data
        } else {
          console.log('Error response status:', response?.status);
        }
      } catch (e) {
        console.log(JSON.stringify(e))
        this.loading = false
      }

      this.loading = false
      return { response_ok: false }
    }

  },

  getters: {
    
    isLoading(state): boolean {
      return state.loading
    }
  }
});